import styled from "styled-components";

export const SingleCollectionContentWrapper = styled.div`
  margin: 120px 0 50px 20px;
  z-index: 1;
  width: 100%;
  @media (max-width: 991.98px) {
    margin: 30px 0;
  }
  @media (max-width: 767.98px) {
    margin-top: 10px;
  }
`;

export const SingleCollectionContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & div {
    background: ${(props) => props.theme.bgColor};
    box-shadow: 1px 6px 20px rgb(0 0 0 / 22%);
    border-radius: 10px;
    width: 299px;
    padding: 15px;
    margin: 20px auto;

    @media (max-width: 1299.98px) {
      width: 30%;
    }
    @media (max-width: 767.98px) {
      width: 30%;
      height: 80px;
      margin: 10px 0;
      padding: 5px;
    }
    & h4 {
      font-family: "Inter";
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 126.2%;
      text-align: center;
      color: ${(props) => props.theme.subtitleColor};
      margin: 10px 0;
      @media (max-width: 767.98px) {
        font-size: 12px;
      }
    }
    & span {
      display: block;
      font-family: "Inter";
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 126.2%;
      text-align: center;
      color: #0088cc;
      margin: 10px 0;
      @media (max-width: 767.98px) {
        font-size: 14px;
      }
    }
  }
`;

export const SingleCollectionContentMain = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
